import { render, staticRenderFns } from "./tablelistWD.vue?vue&type=template&id=38660c34&scoped=true&"
import script from "./tablelistWD.vue?vue&type=script&lang=js&"
export * from "./tablelistWD.vue?vue&type=script&lang=js&"
import style0 from "./tablelistWD.vue?vue&type=style&index=0&id=38660c34&lang=less&scoped=true&"
import style1 from "./tablelistWD.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38660c34",
  null
  
)

export default component.exports